import {
    ACCESS_TOKEN,
    GRAPH_TOKEN,
    StorageService,
} from '../services/storage_service';
import { isJwtExpired } from './isJwtExpired.helper';
import { acquireAccessToken, acquireGraphToken } from '../auth/msal';

export const validateTokens = async () => {
    let accessToken = StorageService.getItem(ACCESS_TOKEN);
    let graphToken = StorageService.getItem(GRAPH_TOKEN);

    if (!isJwtExpired(accessToken) && !isJwtExpired(graphToken)) {
        return {
            accessToken,
            graphToken,
        };
    }

    if (isJwtExpired(accessToken)) {
        // request for new access token
        const tokenResponse: any = await acquireAccessToken();
        accessToken = tokenResponse.accessToken;
        StorageService.setItem(ACCESS_TOKEN, accessToken);
    }
    if (isJwtExpired(graphToken)) {
        // request for new graph token
        const graphApiResponse: any = await acquireGraphToken();
        graphToken = graphApiResponse.accessToken;
        StorageService.setItem(GRAPH_TOKEN, graphToken);
    }

    return {
        accessToken,
        graphToken,
    };
};

export const isTokenExpired = () => {
    const accessToken = StorageService.getItem(ACCESS_TOKEN);
    const graphToken = StorageService.getItem(GRAPH_TOKEN);

    return isJwtExpired(accessToken) || isJwtExpired(graphToken);
}